<div class="status-item-page">
  <app-ticket-status-item-telekom></app-ticket-status-item-telekom>
</div>
